import {
  GroupVisitSessionControllerApi,
  GroupVisitSharedNote,
} from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  sessionId: string;
  groupVisitSharedNote: GroupVisitSharedNote;
};

export const useCreateGroupNote = () =>
  useMutationWithLoading(async ({ sessionId, groupVisitSharedNote }: Params) =>
    new GroupVisitSessionControllerApi(getConfigObject()).createGroupNote(
      sessionId,
      groupVisitSharedNote,
      getXtenantId()
    )
  );
